import axios from 'axios'
import Jimp from 'jimp'

const LIMIT_WIDTH = 500
const LIMIT_HEIGHT = 500

function initialState() {
  return {
    images: {},
    loading: false,
    error: null
  }
}
async function getResizedImage(targetWidth, targetHeight, data) {
  await Jimp.read(data).then(image => {
    image.scaleToFit(targetWidth, targetHeight, Jimp.AUTO).getBuffer(Jimp.AUTO, (err, buffer) => {
      return buffer
    })
  })
}
export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    addImage(state, image) {
      state.images = {
        ...state.images,
        [image._id]: image.data
      }
    },
    addImages(state, newImages) {
      const imgObj = {}
      newImages.forEach(img => (imgObj[img._id] = img.data))
      state.images = {
        ...state.images,
        ...imgObj
      }
    },
    updateImage(state, image) {
      state.images = {
        ...state.images,
        [image._id]: image.data
      }
    },
    deleteImage(state, imageId) {
      delete state.images[imageId]
      state.images = { ...state.images }
    },
    setLoading(state, isLoading) {
      state.loading = isLoading
    },
    setError(state, error) {
      state.error = error
    },
    clear(state) {
      const initState = initialState()
      state = initState
    }
  },
  actions: {
    clear({ commit }) {
      commit('clear')
    },
    async loadThumbnail({ commit }, imageId) {
      commit('setError', null)
      axios
        .get(`${process.env.VUE_APP_API_URL}/images/thumbnail/${imageId}`)
        .then(image => {
          commit('addImage', {
            _id: image._id,
            data: image.data
          })
        })
        .catch(err => commit('setError', err))
    },
    async loadThumbnails({ commit }, field) {
      commit('setError', null)
      const imagesIds = field.data.attrs.options.filter(opt => opt.imgId).map(opt => opt.imgId)
      Promise.all(
        imagesIds.map(imgId =>
          axios.get(`${process.env.VUE_APP_API_URL}/images/thumbnail/${imgId}`)
        )
      )
        .then(results => {
          results.forEach(res => {
            if (res.data)
              commit('addImage', {
                _id: res.data._id,
                data: res.data.data
              })
          })
        })
        .catch(err => commit('setError', err))
    },
    async loadOriginalImages({ commit }, field) {
      commit('setError', null)
      const imagesIds = field.data.attrs.options.filter(opt => opt.imgId).map(opt => opt.imgId)

      imagesIds.forEach(imgId => {
        axios
          .get(`${process.env.VUE_APP_API_URL}/images/original/${imgId}`)
          .then(result => {
            commit('addImage', {
              _id: result.data._id,
              data: Buffer.from(result.data.data.data)
            })
          })
          .catch(err => commit('setError', err))
      })
    },
    async changeOptImage({ commit }, { field, optId, images }) {
      commit('setError', null)
      axios
        .put(`${process.env.VUE_APP_API_URL}/images`, {
          image: images[field.attrs.options[optId].imgId],
          imageId: field.attrs.options[optId].imgId
        })
        .catch(err => commit('setError', err))
    },
    async saveOptImage({ commit }, { field, optId, images }) {
      commit('setError', null)
      axios
        .post(`${process.env.VUE_APP_API_URL}/images/add`, {
          image: images[field.attrs.options[optId].imgId],
          fieldId: fieldId,
          optId: optId
        })
        .catch(err => commit('setError', err))
    },
    async saveFieldImages({ commit }, { field, fieldId, images }) {
      commit('setError', null)
      return new Promise(async (resolve, reject) => {
        for (let i = 0; i < field.attrs.options.length; i++) {
          const option = field.attrs.options[i]
          await (async opt => {
            if (opt.imgId && opt.imgId in images) {
              try {
                await axios.post(`${process.env.VUE_APP_API_URL}/images/add`, {
                  image: images[opt.imgId],
                  fieldId: fieldId,
                  optId: opt.id
                })
              } catch (err) {
                commit('setError', err)
                reject()
              }
            }
          })(option)
        }
        resolve()
      })
    },
    async delete({ commit }, imgId) {
      commit('setError', null)
      try {
        await axios.delete(`${process.env.VUE_APP_API_URL}/images/${imgId}`)
        commit('deleteImage', imgId)
      } catch (err) {
        commit('setError', err)
      }
    },
    async deleteImages({ commit }, imagesIds) {
      commit('setError', null)
      Promise.all(
        imagesIds.map(imgId => axios.delete(`${process.env.VUE_APP_API_URL}/images/${imgId}`))
      ).catch(err => commit('setError', err))
    }
  },
  getters: {
    allImages: state => {
      return state.images
    },
    isError: state => {
      return state.error
    }
  }
}
